import SeleksiVendorAsetApi from "./SeleksiVendorAsetApi";

export default SeleksiVendorAsetApi;
